import React, { useCallback, useState, useContext } from 'react';
import TicketContainer from '@nile/mangifera/src/Containers/TableContainers/TicketContainer';
import TicketContainerNew from '@nile/mangifera/src/Containers/TableContainers/TicketContainerNew';
import TicketKanbanContainer from '@nile/mangifera/src/Containers/PageContainers/TicketKanbanBoard';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { SkeletonTableLoading } from '@nile/components';
import TicketClassicView from '@nile/mangifera/src/Containers/PageContainers/TicketClassicView';

function TicketListContainer(props) {
  const context = useContext(TicketContext);
  const { allEntities, ticketViews, ticketViewMeta } = props;
  const { viewType } = context;

  if (context.viewTypeLoading) return <SkeletonTableLoading />;

  let TicketViewContainer;
  switch (viewType) {
    case 'classic':
      TicketViewContainer = TicketClassicView;
      break;
    case 'kanban':
      TicketViewContainer = TicketKanbanContainer;
      break;
    default:
      TicketViewContainer = TicketContainerNew;
      break;
  }
  return (
    <TicketViewContainer
      allEntities={allEntities}
      ticketViews={ticketViews}
      ticketViewMeta={ticketViewMeta}
    />
  );
}

export default TicketListContainer;
